import { Icon } from '@hai/ui-react';
import React from 'react';

export const EmptyThumbnail = (props: any) => {
  return (
    <div className="empty-thumbnail" {...props}>
      <Icon iconname="StillImageNone" color="haiui-gray-04" size="md" />{' '}
    </div>
  );
};
